// extracted by mini-css-extract-plugin
export var pillWrapper = "_q7-0";
export var showOverflow = "_q7-1";